/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SharedExpense
 */
export interface SharedExpense {
    /**
     *
     * @type {string}
     * @memberof SharedExpense
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof SharedExpense
     */
    amount: string;
}

/**
 * Check if a given object implements the SharedExpense interface.
 */
export function instanceOfSharedExpense(value: object): value is SharedExpense {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SharedExpenseFromJSON(json: any): SharedExpense {
    return SharedExpenseFromJSONTyped(json, false);
}

export function SharedExpenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedExpense {
    if (json == null) {
        return json;
    }
    return {

        'description': json['description'],
        'amount': json['amount'],
    };
}

  export function SharedExpenseToJSON(json: any): SharedExpense {
      return SharedExpenseToJSONTyped(json, false);
  }

  export function SharedExpenseToJSONTyped(value?: SharedExpense | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'description': value['description'],
        'amount': value['amount'],
    };
}
